var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.675 9.923c.22 0 .386-.07.51-.202l3.62-3.639a.685.685 0 00.22-.527.753.753 0 00-.22-.528l-3.62-3.673a.65.65 0 00-.51-.211c-.396 0-.695.316-.695.72 0 .185.07.36.194.501l2.347 2.303A8.816 8.816 0 0012 4.527a7.742 7.742 0 00-7.77 7.76A7.751 7.751 0 0012 20.065a7.744 7.744 0 007.76-7.778.702.702 0 00-.729-.73c-.413 0-.685.308-.685.73A6.33 6.33 0 0112 18.65a6.337 6.337 0 01-6.354-6.363A6.328 6.328 0 0112 5.941c.668 0 1.283.053 1.81.167l-2.627 2.61a.727.727 0 00-.203.502c0 .404.3.703.695.703z"
  })));
}

export default __webpack_public_path__ + "static/media/refresh.309cb26a.svg";
export { SvgRefresh as ReactComponent };